import { deleteJson, fetchBlob, getJson, pathSegment, queryString } from "../client";
import { RESUME_BASE } from "./base";

/** Every resume tailored for the person, and one as its PDF. */

/**
 * One resume tailored for the person: what it was written for, when, and
 * by which model. `resume_api::responses::TailoredResumeSummary`. The
 * posting's title and company are envoy's and the catalogue's.
 */
export interface TailoredResumeSummary {
    resume_id: string;
    application_id: string;
    posting_id: string;
    /** The application's tailor attempt, from one. */
    attempt: number;
    byte_size: number;
    stored_at: string;
    /** Absent for a resume kept before the model was recorded. */
    model?: string | null;
}

/** A page of them, the newest first. `resume_api::responses::TailoredResumeList`. */
export interface TailoredResumeList {
    tailored: TailoredResumeSummary[];
    next_cursor?: string | null;
}

/** The most a page may hold, as the service allows. */
export const MAX_TAILORED_PAGE = 100;

/** A page of the person's tailored resumes, the newest first, after `cursor`. */
export function listTailored(cursor?: string, limit?: number): Promise<TailoredResumeList> {
    return getJson(`${RESUME_BASE}/tailored${queryString({ cursor, limit })}`);
}

/**
 * Deletes a tailored resume and its file for good. Refused while its
 * application is not finished; doing it again changes nothing.
 */
export function deleteTailored(resumeId: string): Promise<unknown> {
    return deleteJson(`${RESUME_BASE}/tailored/${pathSegment(resumeId)}`);
}

/**
 * One tailored resume's PDF, through the API rather than its signed
 * link: the page frames only what it made, so the PDF is shown from a
 * blob of these bytes.
 */
export function getTailoredPdf(resumeId: string): Promise<Blob> {
    return fetchBlob(`${RESUME_BASE}/tailored/${pathSegment(resumeId)}/pdf`);
}
